export enum CheckNotificationTypesEnum {
  HAS_PLANS_IN_PROCESS = 'HAS_PLANS_IN_PROCESS',
  HAS_PLANS_IN_PROCESS_OR_UNDER_CONSIDERATION = 'HAS_PLANS_IN_PROCESS_OR_UNDER_CONSIDERATION',
  HAS_PLANS_NOT_APPROVED = 'HAS_PLANS_NOT_APPROVED',
  GENERAL_PROSECUTOR_ADDED = 'GENERAL_PROSECUTOR_ADDED',
  FOR_CREATE_KNM_WITH_GENERAL_PROSECUTOR = 'FOR_CREATE_KNM_WITH_GENERAL_PROSECUTOR',
  FOR_CREATE_PLAN_WITH_GENERAL_PROSECUTOR = 'FOR_CREATE_PLAN_WITH_GENERAL_PROSECUTOR',
  NONE = 'NONE',
}
